import * as actions from './actions'

const CancelledDeliveriesSettingsStore = {
  state: {},
  getters: {},
  mutations: {},
  actions
}

export default CancelledDeliveriesSettingsStore
